import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service'
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  smsTemplate: any
  emailTemplate: any
  contactList: any
  contactDa: any

  selectedSms = ""
  smsText = ""
  submittedSms = false

  selectedEmail = ""
  emailText = ""
  submittedEmail = false

  attachments = ""

  isCheckedAll = false
  selectList: any
  confirmMergeList : any = {
    firstname: "",
    lastname: "",
    birthdate: "",
    dpa_idcard: "",
    emailaddress1: "",
    telephone1: "",
    dob: ""
  }

  firstnameSearch: string = ""
  lastnameSearch: string = ""
  telephoneSearch: string = ""
  idcardSearch: string = ""
  accountNoSearch: string = ""

  contact1: any = {
    firstname: "",
    lastname: "",
    birthdate: "",
    dpa_idcard: "",
    emailaddress1: "",
    telephone1: "",
    dob: ""
  }
  contact2: any = {
    firstname: "",
    lastname: "",
    birthdate: "",
    dpa_idcard: "",
    emailaddress1: "",
    telephone1: "",
    dob: ""
  }

  chkMain = 1

  chkName = 1
  chkLastname = 1
  chkDob = 1
  chkIdNo = 1
  chkEmail = 1
  chkTel = 1

  dtCon: any = null

  role: any = {}
  cookieData: any
  isCrisis = true
  idCard = ""
  telephoneNo = ""

  contactDros: any

  @ViewChildren('tbCon') tbCon: QueryList<any>;

  constructor(
    private util: UtilService,
    private router: Router,
    private apiService: ApiService
  ) { }

  async ngOnInit() {
    let thisTs = this

    this.util.ShowWaiting(true)
    this.util.InitValidation()

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.isCrisis = this.cookieData.isCrisis

    await this.callApi()

    try {
      $('#summernote').summernote({
        placeholder: '',
        tabsize: 2,
        height: 120,
        toolbar: [
          ['style', ['style']],
          ['font', ['bold', 'underline', 'clear']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['table', ['table']],
          ['insert', ['link', 'picture', 'video']],
          ['view', ['fullscreen', 'codeview', 'help']]
        ]
      });

    }
    catch (e) {
      this.util.ShowWaiting(false)
    }
  }

  callApi() {
    Observable.forkJoin(
      this.apiService.get("master", "externalSmsTemplate"),
      this.apiService.get("master", "externalEmailTemplate")
    ).subscribe(
      async data => {
        this.smsTemplate = data[0]
        this.emailTemplate = data[1]
        
        this.util.ShowWaiting(false)
      },
      err => {
        console.error(err)
        this.util.ShowWaiting(false)
      }
    );
  }


  clearActionActive() {
    $(".action-menu").each(function () {
      $(this).removeClass("active")
    })
  }

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
    this.clearActionActive()
  }

  newContact(event: any) {
    const url = this.util.baseUrl() + `/newContact`
    window.open(url, '_blank');
  }

  delete(event: any) {
    this.getSelectedContact()
    if (this.selectList.length < 1) {
      this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
    }
    else {
      this.clearActionActive()
      event.target.classList.add("active")
      $("#deleteModal").modal('show')
    }
  }

  async merge(event: any) {
    this.getSelectedContact()
    if (this.selectList.length != 2) {
      this.util.WarningDialog("กรุณาเลือก 2 รายการ");
    }
    // else if (this.selectList[0].fullname != this.selectList[1].fullname) {
    //   this.util.WarningDialog("กรุณาเลือก 2 รายการที่มีชื่อ นามสกุล ตรงกัน");
    // }
    else {
      this.util.ShowWaiting(true)
      let c: any
      c = await this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[0].contactId)
      this.contact1 = c[0]
      c = await this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[1].contactId)
      this.contact2 = c[0]

      if (this.contact1 == null && this.contact2 == null) {
        this.util.ErrorDialog("เกิดข้อผิดพลาดในการดึงข้อมูล Contact");
      }
      else {
        this.contact1.dob = this.contact1.birthdate
        this.contact2.dob = this.contact2.birthdate
        this.mainChange(1)

        this.clearActionActive()
        event.target.classList.add("active")
        $("#mergeModal").modal('show')
      }
      this.util.ShowWaiting(false)
    }
  }
  sms(event: any) {
    this.getSelectedContact()
    if (this.selectList.length < 1) {
      this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
    }
    else {

      let invalidTelNo: any = this.selectList.filter((s: any) => {
        return s.tel == null || !this.util.isValidTelNo(s.tel)
      });

      if (invalidTelNo != null && invalidTelNo.length > 0) {
        this.util.WarningDialog("กรุณาเลือกรายการที่เบอร์มือถือ ถูกต้องเท่านั้น");
      }
      else {
        this.clearActionActive()
        event.target.classList.add("active")

        this.selectedSms = ""
        this.smsText = ""
        this.submittedSms = false

        $("#smsModal").modal('show')
      }
    }
  }
  email(event: any) {
    this.getSelectedContact()
    if (this.selectList.length < 1) {
      this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
    }
    else {
      let invalidEmail: any = this.selectList.filter((s: any) => {
        return s.email == null || !this.util.isValidEmail(s.email)
      });

      if (invalidEmail != null && invalidEmail.length > 0) {
        this.util.WarningDialog("กรุณาเลือกรายการที่ Email ถูกต้องเท่านั้น");
      }
      else {
        this.clearActionActive()
        event.target.classList.add("active")

        this.selectedEmail = ""
        this.emailText = ""
        this.attachments = ""
        this.submittedEmail = false
        $('#summernote').summernote('code', '')

        $("#emailModal").modal('show')
      }
    }
  }
  
  async beforeConfirmMerge() {
    this.util.ShowWaiting(true)

    let req: any = this.chkMain == 1 ? this.contact1 : this.contact2
    req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname
    req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname
    req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate
    req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard
    req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1
    req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1
    req.dpa_modifiedby = this.cookieData.userId

   
    this.confirmMergeList = req; 
     
    
    $("#mergeConfirmModal").modal('show')    
    $("#mergeModal").modal('hide')
    
    this.util.ShowWaiting(false)
     
  }


  async confirmMerge() {
    this.util.ShowWaiting(true)

    let req: any = this.chkMain == 1 ? this.contact1 : this.contact2
    req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname
    req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname
    req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate
    req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard
    req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1
    req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1
    req.dpa_modifiedby = this.cookieData.userId

    var res: any = await this.apiService.put("crmservice", "contact-merge/" + this.contact1.contactid + "/" + this.contact2.contactid, req);
    if (this.util.isSuccessResponse(res)) {
      //await this.search(true)
      $('#tbContact').DataTable().clear().destroy();
      $("#mergeConfirmModal").modal('hide')
      this.util.SuccessDialog("Merge conatct สำเร็จ")
    }
    else {
      this.util.ErrorDialog("Merge conatct ไม่สำเร็จ")
    }
    this.util.ShowWaiting(false)
  }

  async confirmSMS() {
    this.submittedSms = true
    if (this.selectedSms != "") {
      this.util.ShowWaiting(true)
      let success = 0, fail = 0

      for (let i = 0; i < this.selectList.length; i++) {
        let contactId: any = this.selectList[i].contactId
        let tel: any = this.selectList[i].tel
        let req: any = {
          contactid: contactId,
          dpa_description: "",
          dpa_phoneno: tel,
          template: this.selectedSms,
          dpa_createdby: this.cookieData.userId
        }
        let res: any = await this.apiService.post("crmservice", "sendSms", req)

        if (this.util.isSuccessResponse(res)) {
          ++success
        }
        else {
          ++fail
        }
      }

      this.util.ShowWaiting(false)

      //some case fail some case success
      if (fail > 0 && success > 0) {
        this.util.WarningDialog("ส่ง SMS สำเร็จจำนวน: " + success + " Contact, ส่ง SMS ไม่สำเร็จจำนวน: " + fail + " Contact")
        $("#smsModal").modal('hide')
      }
      //no case fail no case success
      else if (fail == 0 && success == 0) {
        this.util.ErrorDialog("ส่ง SMS ไม่สำเร็จ")
      }
      //fail
      else if (fail > 0 && success == 0) {
        this.util.ErrorDialog("ส่ง SMS ไม่สำเร็จ")
      }
      //success
      else {
        this.util.SuccessDialog("ส่ง SMS สำเร็จ")
        $("#smsModal").modal('hide')
      }

    }
  }

  async confirmEmail() {
    this.submittedEmail = true
    if (this.selectedEmail != "") {

      this.util.ShowWaiting(true)
      let success = 0, fail = 0

      for (let i = 0; i < this.selectList.length; i++) {
        let contactId: any = this.selectList[i].contactId
        let email: any = this.selectList[i].email
        let req: any = {
          contactid: contactId,
          dpa_name: "",
          dpa_description: $('#summernote').summernote('code'),
          //dpa_emailaddress: email,
          //template: this.selectedEmail,
          dpa_casesubtypedetailid: null,
          dpa_createdby: this.cookieData.userId,
          dpa_customwebuserid: this.cookieData.userId,
          dpa_callby: 1
        }
        let res: any = await this.apiService.post("crmservice", "sendEmail2", req)

        if (this.util.isSuccessResponse(res)) {
          ++success
        }
        else {
          ++fail
        }
      }

      this.util.ShowWaiting(false)

      //some case fail some case success
      if (fail > 0 && success > 0) {
        this.util.WarningDialog("ส่ง Email สำเร็จจำนวน: " + success + " Contact, ส่ง Email ไม่สำเร็จจำนวน: " + fail + " Contact")
        $("#emailModal").modal('hide')
      }
      //no case fail no case success
      else if (fail == 0 && success == 0) {
        this.util.ErrorDialog("ส่ง Email ไม่สำเร็จ")
      }
      //fail
      else if (fail > 0 && success == 0) {
        this.util.ErrorDialog("ส่ง Email ไม่สำเร็จ")
      }
      //success
      else {
        this.util.SuccessDialog("ส่ง Email สำเร็จ")
        $("#emailModal").modal('hide')
      }
    }
  }

  async confirmDelete() {
    this.util.ShowWaiting(true)
    let success = 0, fail = 0

    for (let i = 0; i < this.selectList.length; i++) {
      let contactId: any = this.selectList[i].contactId
      let req: any = this.contactList.filter((c: any) => {
        return c.contactid == contactId
      })
      req[0].dpa_modifiedby = this.cookieData.userId,
        req[0].statusreason = 2

      var res: any = await this.apiService.put("crmservice", "contact/" + contactId, req[0]);
      if (this.util.isSuccessResponse(res)) {
        ++success
      }
      else {
        ++fail
      }
    }

    //some case fail some case success
    if (fail > 0 && success > 0) {
      this.util.WarningDialog("ลบสำเร็จจำนวน: " + success + " Contact, ลบไม่สำเร็จจำนวน: " + fail + " Contact")
    }
    //no case fail no case success
    else if (fail == 0 && success == 0) {
      this.util.ErrorDialog("ลบ Contact ไม่สำเร็จ")
    }
    //fail
    else if (fail > 0 && success == 0) {
      this.util.ErrorDialog("ลบ Contact ไม่สำเร็จ")
    }
    //success
    else {
      $("#deleteModal").modal('hide')
      this.util.SuccessDialog("ลบ Contact สำเร็จ")
    }
    //await this.search(true)

    $('#tbContact').DataTable().clear().destroy();
    this.util.ShowWaiting(false)
  }

  smsChange() {
    let selectd = this.smsTemplate.filter((e: any) => e.dpa_externalsmstemplateid == this.selectedSms)
    if (selectd != null && selectd.length > 0) {
      this.smsText = selectd[0].dpa_templatebodysms
    }
    else {
      this.smsText = ""
    }
  }

  emailChange() {
    let selectd = this.emailTemplate.filter((e: any) => e.templateid == this.selectedEmail)
    if (selectd != null && selectd.length > 0) {
      this.emailText = selectd[0].body
      $('#summernote').summernote('code', this.emailText)
      if (selectd[0].attachments != null && selectd[0].attachments.length > 0) {
        let att: any = selectd[0].attachments.map((a: any) => { return a.filename })
        this.attachments = att.join(" ,  ")
      }
      else {
        this.attachments = ""
      }
    }
    else {
      this.emailText = ""
      this.attachments = ""
    }
  }

  onCheckAllChange() {
    $(".row-checker").prop("checked", this.isCheckedAll)
  }

  getSelectedContact() {
    let thisTs = this
    this.selectList = []
    $('.row-checker:checkbox:checked').each(function () {
      let value = {
        contactId: $(this).val(),
        fullname: $(this).closest('tr').find('td.col-fullname')[0].innerHTML,
        tel: $(this).closest('tr').find('td.col-tel')[0].innerHTML,
        email: $(this).prop("name")
      }
      thisTs.selectList.push(value)
    })
  }

  async search(getAll: boolean = false) {

    try {
      let filtered: any = []

      if (getAll) {

        this.util.ShowWaiting(true)

        $('#tbContact').DataTable().clear().destroy();

        filtered = await this.apiService.get("crmservice", "contact")

        this.contactList = filtered.filter((c: any) => {
          return c.statusreason == 1 || c.statusreason == "1"
        });
        this.util.ShowWaiting(false)
      }
      else {
        let para = ""
        let telnumber = ""
        if (this.firstnameSearch.trim() != "") {
          para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameSearch
        }
        if (this.lastnameSearch.trim() != "") {
          para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameSearch
        }
        if (this.telephoneSearch.trim() != "") {
          para += (para.length > 0 ? "&" : "") + "telephoneno=" + this.telephoneSearch
          telnumber = this.telephoneSearch
        }
        if (this.idcardSearch.trim() != "") {
          para += (para.length > 0 ? "&" : "") + "idcard=" + this.idcardSearch
        }
        if (this.accountNoSearch.trim() != "") {
          para += (para.length > 0 ? "&" : "") + "accountno=" + this.accountNoSearch
        }

        if (para.length > 0) {

          this.util.ShowWaiting(true)

          $('#tbContact').DataTable().clear().destroy();

          filtered = await this.apiService.get("crmservice", "contact", para)

          if (filtered != null && filtered.length > 0) {
            this.contactList = filtered.filter((c: any) => {
              return c.statusreason == 1 || c.statusreason == "1"
            });
          }
          else {
            if (this.isCrisis) {
              await this.getDrosContact()
              await this.getDAContact()

              if (this.contactDros != null && this.contactDros.CRM06 != null) {
                //create crm contact ด้วยข้อมูลจาก DROS

                let firstname = ""
                let lastname = ""
                try {
                  let name: string = this.contactDros.CRM06.Name.split(" ")
                  if (name.length > 0) {
                    if (name.length == 1) {
                      firstname = name[0]
                    }
                    else if (name.length == 2) {
                      firstname = name[0]
                      lastname = name[1]
                    }
                    else {
                      for (let i = 0; i < name.length - 1; i++) {
                        firstname += " " + name[i]
                      }
                      firstname = firstname.trim()
                      lastname = name[name.length - 1]
                    }
                  }
                }
                catch (e) {
                  console.log(e)
                }

                let req: any = {
                  createdon: new Date().toISOString(),
                  modifiedon: new Date().toISOString(),
                  firstname: firstname,
                  lastname: lastname,
                  dpa_idcard: this.contactDros.CRM06.IDNo,
                  dpa_authorizedperson_idcard: this.contactDros.CRM06.IDNo,
                  dpa_authorizedperson_telephone: this.contactDros.CRM06.PhoneNo,
                  telephone1: telnumber,
                  emailaddress1: this.contactDros.CRM06.Email,
                  statusreason: 1,
                  //callcenterflag: true
                }

                await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
                  if (this.util.isSuccessResponse(res)) {
                    if (res.contactid != null && res.contactid != "") {
                      //new tab customer4tab (2)
                      this.search()
                    }
                    else {
                      this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ")
                    }
                  }
                  else {
                    this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ")
                  }
                })
              }
              else if(this.contactDa != null && this.contactDa.FirstName != null)
              {
                
                let phone: string = this.contactDa.MobileNumber.split(",")
                let firstname = this.contactDa.FirstName
                let lastname = this.contactDa.LastName
                let phoneNo =  ""   
                if(telnumber != null && telnumber.trim().length > 0) 
                { 
                  phoneNo = telnumber
                } 
                else
                {
                  if (phone.length > 0 && phone[0] != "N/A")
                  {
                    phoneNo = phone[0]
                  }
                  else
                  {
                    phoneNo = telnumber
                  }
                  
                }

                let req: any = {
                  createdon: new Date().toISOString(),
                  modifiedon: new Date().toISOString(),
                  firstname: firstname,
                  lastname: lastname,
                  dpa_idcard: this.contactDa.IdentityNumber,
                  dpa_authorizedperson_idcard: this.contactDa.IdentityNumber,
                  dpa_authorizedperson_telephone: phoneNo,
                  telephone1: phoneNo,
                  emailaddress1: this.contactDa.EmailAddress,
                  statusreason: 1,
                  //callcenterflag: true
                }

                await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
                  if (this.util.isSuccessResponse(res)) {
                    if (res.contactid != null && res.contactid != "") {
                      //new tab customer4tab (2)
                      //this.router.navigate(["/customer/" + res.contactid])
                      this.search()
                    }
                    else {
                      this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ")
                    }
                  }
                  else {
                    this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ")
                  }
                })
              }
              else {
                console.log("ไม่พบข้อมูล")
                this.util.WarningDialog("ไม่พบข้อมูล")
              }
            }
          }

          this.util.ShowWaiting(false)
        }
        else {
          this.util.WarningDialog("กรุณาระบุเงื่อนไขในการค้นหา")
        }
      }
    }
    catch (e) {
      console.error(e)
    }
  }

  resetSearchCirteria() {
    this.firstnameSearch = ""
    this.lastnameSearch = ""
    this.telephoneSearch = ""
    this.idcardSearch = ""
    this.accountNoSearch = ""
  }

  ngAfterViewInit() {
    this.tbCon.changes.subscribe(t => {
      this.initTableCon()
    })
  }

  ngForRendred() {
    console.log('NgFor is Rendered');
    if (this.dtCon == null) {
      this.initTableCon()
    }
  }

  initTableCon() {
    let thisTs = this

    $('#tbContact td:not(.checkbox-col)').click(async function (event: any) {
      // if(thisTs.isCrisis){
      //   await thisTs.getDrosContact()

      //   if(thisTs.contactDros != null && thisTs.contactDros.length > 0){
      //     const url = thisTs.util.baseUrl() + `/customer/` + $(this).parent('tr').find("input[type='checkbox']")[0].value
      //     window.open(url, '_blank');
      //   }
      //   else{
      //     thisTs.util.ErrorDialog("ไม่พบข้อมูลใน DROS กรุณาติดต่อเจ้าหน้าที่")
      //   }
      // }
      // else{
      const url = thisTs.util.baseUrl() + `/customer/` + $(this).parent('tr').find("input[type='checkbox']")[0].value
      window.open(url, '_blank');
      // }
    });

    this.dtCon = $("#tbContact").DataTable({
      retrieve: true,
      'searching': false,
      "order": [],
      columnDefs: [{ orderable: false, targets: [0] }]
    });
  }

  mainChange(num: number) {
    this.chkMain = num
    this.chkName = num
    this.chkLastname = num
    this.chkDob = num
    this.chkIdNo = num
    this.chkEmail = num
    this.chkTel = num
  }

  async getDrosContact() {
    let para = "CRM06=true"
    if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
      para += "&dpa_id=" + this.idcardSearch
    }
    if (this.telephoneSearch != null && this.telephoneSearch.toString().trim().length > 0) {
      para += "&telephoneno=" + this.telephoneSearch
    }
    this.contactDros = await this.apiService.get("crmservice", "contactDros", para)//ค้น DROS
  }

  async getDAContact(){
    let para = ""
    if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
      para += "IdNo=" + this.idcardSearch
    } 
    this.contactDa =  await this.apiService.get("crmservice", "getDA", para)//ค้น DA
  }

  ngOnDestroy(){
    $('#summernote').summernote('destroy')
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts